export const facebookConfig = {
	metaImage: {
		height: 628,
		type: 'image/jpeg',
		url: '/content/space-default',
		width: 1200,
	},
} as const
